<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="60" inline>
        <FormItem label="姓名">
          <Input placeholder="请输入" v-model="table.search.PatientName"></Input>
        </FormItem>
        <FormItem label="证件号">
          <Input placeholder="请输入" v-model="table.search.IdentityID"></Input>
        </FormItem>
        <FormItem label="身份证">
          <Input placeholder="请输入" v-model="table.search.IDCardNO"></Input>
        </FormItem>
        <FormItem label="医保号">
          <Input placeholder="请输入" v-model="table.search.InsuranceID"></Input>
        </FormItem>
        <FormItem label="手机号">
          <Input placeholder="请输入" v-model="table.search.TelePhone"></Input>
        </FormItem>
      </Form>
      <!--操作区域-->
      <div>
        <Button class="mr-3" type="success" @click="search">查询</Button>
      </div>

    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--更新-->
    <Modal
      v-model="editModal"
      title="编辑版本"
      :footer-hide="true"
      
      :closable="false"
    >
      <patientedit
        v-if="editModal"
        @close="editModal = false"
        @loadData="search"
        :currentData="currentData"
      ></patientedit>
    </Modal>

    <!--详情-->
    <Modal
      v-model="detailModal"
      title="查看"
      :footer-hide="true"
      
      :closable="false"
    >
      <patientdetail
        v-if="detailModal"
        @close="detailModal = false"
        :currentData="currentData"
      ></patientdetail>
    </Modal>
    <!--详情-->
    <Modal
      v-model="reportdetailModal"
      title="历史病历详情"
      width="768"
      :footer-hide="true"
      
      :closable="false"
    >
      <patientreportdetail
        v-if="reportdetailModal"
        @close="reportdetailModal = false"
        :currentData="currentData"
      ></patientreportdetail>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";

import patientedit from "../patient/edit.vue";
import patientdetail from "../patient/detail.vue";
import patientreportdetail from "../patient/reportdetail.vue";

export default {
  components: { DataTable, patientedit, patientdetail, patientreportdetail },
  data: function () {
    return {
      currentData: {},
      detailModal: false,
      addModal: false,
      editModal: false,
      reportdetailModal: false,
      selectedClientIds: [],
      selectionData: [],
      table: {
        columns: [
          //   {
          //     type: "selection",
          //     width: 60,
          //     align: "center",
          //   },
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "患者姓名", key: "patientName" },
          { title: "生日", key: "patientBirthday" },

          {
            title: "性别",
            key: "patientSex",
            render: (h, value) => {
              let sex = "";
              switch (value.row.patientSex) {
                case "F":
                  sex = "女";
                  break;
                case "M":
                  sex = "男";
                  break;
                default:
                  sex = "未知";
                  break;
              }
              return h("div", sex);
            },
          },
          { title: "身份证号", key: "idCardNO" },
          { title: "手机号", key: "telePhone", tooltip: true },

          {
            title: "操作",
            width: "210px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toReportDetail(params.row);
                      },
                    },
                  },
                  "查看病历"
                ),
              ]);
            },
          },
        ],
        apiUrl: "patient/GetPationInfoList",
        search: {
          PatientName: "",
          IdentityID: "",
          InsuranceID: "",
          TelePhone: "",
          IDCardNO: "",
        },
      },
    };
  },

  created: function () {},
  activated(){
    this.search()
 },

  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },
    init: function () {
      this.$api.post("/patient/init").then((rsp) => {
        if (rsp.statusCode == "200") {
          this.$Message.success(rsp.msg);
          this.search();
        } else {
          this.$Message.success("初始化失败");
        }
      });
    },
    toReportDetail: function (data) {
      this.reportdetailModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },

    toEdit: function (data) {
      this.editModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },

    addModelChange(data) {
      if (
        data &&
        document.getElementsByClassName("ivu-upload-list").length > 0
      ) {
        document.getElementsByClassName("ivu-upload-list")[0].innerHTML = "";
      }
    },
    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
</style>